import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const ApiDocs = lazy(() => import("./ApiDocs"));
const ManageKeys = lazy(() => import("./ManageKeys"));

export const automationAPIRoutes: RouteObject[] = [
  {
    path: `api/docs`,
    element: <ApiDocs />
  },
  {
    path: `api/manage-keys`,
    element: <ManageKeys />
  }
];
